import React from 'react'
import { Typography } from 'components/Contentful'
import { AchieveLink } from '@/components/AchieveLink'
import { ChevronRight } from 'react-feather'
import { Carousel } from '@/components/Carousels'
import { DebtSolutionsArticleCard } from './DebtSolutionArticleCard'

export const ArticlesTab = ({ list }) => {
  return (
    <>
      <div className="mt-[48px] hidden md:flex flex-row justify-center gap-[40px]">
        {list.map((article, id) => {
          const { title, slug, mainImage, hook, author } = article
          return (
            <DebtSolutionsArticleCard
              key={id}
              id={id}
              title={title}
              slug={slug}
              mainImage={mainImage}
              hook={hook}
              author={author}
            />
          )
        })}
      </div>

      <Carousel
        carouselItems={list}
        itemComponent={({ item: cardItem, index }) => {
          const { title, slug, mainImage, hook, author } = cardItem
          return (
            <DebtSolutionsArticleCard
              key={cardItem.sys?.id ?? index}
              id={index}
              title={title}
              slug={slug}
              mainImage={mainImage}
              hook={hook}
              author={author}
            />
          )
        }}
        idPrefix="value-props-carousel"
        className={'p-0 pl-0! md:hidden mt-[26px]'}
        withIndicators={true}
        variant="center"
        variationDot={'onWhite'}
        classNameIndicatorDots={'bg-[#3300ff]'}
        classNameIndicators="mt-0!"
        classNameWrapper="mt-0! !sm:mt-[23px] flex md:hidden"
      />
      <div className="w-full mt-[50px] justify-center mb-[20px] hidden md:flex">
        <AchieveLink href={'/learn'}>
          <div className="flex flex-row justify-center align-center">
            <Typography content={'View all articles '} />
            <ChevronRight />
          </div>
        </AchieveLink>
      </div>
    </>
  )
}
